export const propidToPrettyName = {
  400550: {
    1394: "Central",
    1052: "Ivanhoe",
    1049: "Park",
    792: "Mills",
    532: "Corrine",
  },
  400890: {
    1034: "Captiva",
    963: "Naples",
    946: "Anna Maria",
    779: "Destin",
    626: "Clearwater",
    539: "Siesta Key",
  },
  401310: {
    1177: "The Gatlin",
    1045: "The Anderson",
    1020: "The Hoffner",
    795: "The Ashford",
    773: "The Briercliff",
    658: "The Grant",
  },
  401730: {
    960: "Granada",
  },
  402180: {
    1330: "Bruco",
    1260: "Tartuca",
    1248: "Leocorno",
    1059: "Pantera",
    1003: "Oca",
    830: "Giraffa",
    780: "Onda",
    760: "Aquila",
    629: "Selva",
  },
  400470: {
    960: "Discovery",
    510: "Aqua",
  },
  406470: {
    1030: "Dunns Creek",
    950: "Caladesi Island",
    808: "Alafia River",
    850: "Alafia River",
    650: "Avalon",
    450: "Silver Springs",
    390: "Estereo Bay",
  },
  400450: {
    750: "George",
    700: "Fredrica",
    580: "Barber",
    519: "Gatlin",
  },
  401470: {
    600: "Thornton",
    500: "Eola",
  },
  400530: {
    1200: "Cooper",
    1100: "Wright",
    1000: "Earhart",
    744: "Maverick",
    440: "Sully",
  },
  400330: {
    1296: "Amistad",
    1070: "Dorado",
    962: "Felicidad",
    709: "Castillo",
  },
  400510: {
    930: "Millenia",
    850: "The Florida",
  },
  400480: {
    1100: "Spruce",
    1000: "Cypress",
    800: "Torrey Pine",
  },
  400860: {
    540: "Blackberry Lily",
    510: "Blue Flag",
  },
  400540: {
    1002: "Jupiter",
    650: "Mira",
    501: "West Palm",
  },
  407430: {
    2350: "The George #6",
    1160: "The Earhart #3",
    1000: "The Jewell #2",
    795: "The William #1",
    1450: "The James #7",
    765: "The Christine #5",
    645: "The Drynoch #4",
    635: "The Clark #8",
  },
};

export const findPrettyName = (n) => {
  let inputString = n.MRKTNAME;
  let targetString; //adding for McMansion bugs or other strings that do not fit the mold

  if (inputString.includes(",")) {
    let commaSeparatedArray = inputString.split(",");
    targetString = commaSeparatedArray[1].trim();
  } else {
    let spaceSeparatedArray = inputString.split(" ");
    targetString = spaceSeparatedArray[0].trim();
  }

  let firstItem = parseInt(targetString);

  let prettyName = propidToPrettyName[n.RMPROPID][firstItem]
    ? propidToPrettyName[n.RMPROPID][firstItem]
    : "Unk";
  return prettyName;
};

export const northSlugs = [
  "aspen-chase",
  "evergreen",
  "glencoe-hills",
  "glencoe-oaks",
  "hillcrest",
  "manchester-flats",
  "manchester-west",
  "mcdonald-mansion",
  "meadowbrook-village",
  "medical-center-court",
  "park-place",
  "roundtree",
  "spruce-knob",
  "state-street-village",
  "the-villas",
  "traver-courts",
  "traver-crossing",
  "traver-heights",
  "traver-ridge",
  "schooner-cove",
];

export const southSlugs = [
  "amalfi",
  "aria-beach",
  "azure",
  "bella-capri",
  "bella-casa",
  "bella-vita",
  "bellagio",
  "celano",
  "coconut-palms",
  "conway-forest",
  "harbor-beach",
  "indigo",
  "iris-flats",
  "monterey-lake",
  "palio",
  "portofino",
  "positano",
  "riva",
  "sapphire",
  "serena",
  "studioparc",
  "the-frederick",
  "the-pines",
  "westwood-suites",
  "bayshore-flats",
  "beach-flats",
  "brooklyn-flats",
  "carlyle-flats",
  "delaney-flats",
  "esperanza-san-pedro-flats",
  "eusonian",
  "harper-flats",
  "hyde-park-flats",
  "ivy-flats",
  "olivia-flats",
  "parkland-flats",
  "piccadilly-flats",
  "schoolhouse-flats",
  "westshore-flats",
  "willow-flats",
  "Positano",
];

// Function to determine if a slug is in the north or south
export const getRegionBySlug = (slug) => {
  if (northSlugs.includes(slug)) {
    return "north";
  } else if (southSlugs.includes(slug)) {
    return "south";
  } else {
    return "unknown";
  }
};
